<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-5 mt-1" >
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-row class="mx-0 my-0 px-0 py-0" justify="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="right white_highlight--text tools-view-height mx-1" color="secondary" @click="downloadLabels" style="max-width: 40px !important; min-width: 40px !important" >
                                    <v-icon class="material-icons-outlined" small>label</v-icon>
                                </v-btn>
                            </template>

                            <span>{{$t('guides.download')}}</span>
                        </v-tooltip>
    
                        <v-tooltip bottom v-permission="'customer_guides_b2c.create'">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="right white_highlight--text tools-view-height mx-1" color="secondary" @click="modal_create = true" style="max-width: 40px !important; min-width: 40px !important" >
                                    <v-icon class="material-icons-outlined" small>add</v-icon>
                                </v-btn>
                            </template>

                            <span>{{$t('guides.add')}}</span>
                        </v-tooltip>
                    </v-row>
                </v-col>
            </v-row>
            
            <v-card class="px-0 top_bar mb-3">
                <v-card-text class="py-0 my-0">
                    <v-row class="px-0 py-0 my-0" style="max-height: 43px !important; min-height: 43px !important;" align="center">
                        <v-col cols="8" class="py-0 my-0 px-0">
                            <v-tabs v-model="tab"  active-class="customers_active_tab" style="max-height: 43px !important;">
                                <v-tabs-slider class="slider" color="secondary" style="margin: 0px !important;"></v-tabs-slider>
                                <v-tab v-for="item in tab_items" :key="item" class="non_selected_tab slider" style="max-height: 43px !important;">
                                    {{ item }}
                                </v-tab>
                            </v-tabs>
                        </v-col>
                        
                        <v-spacer></v-spacer>
                    </v-row>
                </v-card-text>
            </v-card>
                        
            <v-tabs-items v-model="tab" class="px-0 mx-3 ">
                <v-tab-item class="px-0 mx-0">
                    <v-card class="size_tab mx-0 px-0" flat>
                        <v-card-text class="px-0 mx-1">
                            <v-row class="px-0 mx-0">
                                <v-col class="py-0 px-0 mx-0">
                                    <datatable :showSelect="true" :item_key="'id'" @input:selected="handleSelected($event, 'created')" :props="{ headers: headers, items: props.items, search: props.search}" :itemsLength="props.meta.total" @update:options="onOptionsChange" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item class="px-0 mx-0">
                    <v-card class="size_tab mx-0 px-0" flat>
                        <v-card-text class="px-0 mx-1">
                            <v-row>
                                <v-col class="py-0">
                                    <datatable :showSelect="true" :item_key="'id'" @input:selected="handleSelected($event, 'in_transit')" v-model="items_selected_in_transit" :props="{ headers: headers, items: props.items, search: props.search}" :itemsLength="props.meta.total" @update:options="onOptionsChange" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                
                <v-tab-item class="px-0 mx-0">
                    <v-card class="size_tab mx-0 px-0" flat>
                        <v-card-text class="px-0 mx-1">
                            <v-row>
                                <v-col class="py-0">
                                    <datatable :showSelect="true" :item_key="'id'" @input:selected="handleSelected($event, 'delivered')" v-model="items_selected_delivered" :props="{ headers: headers, items: props.items, search: props.search}" :itemsLength="props.meta.total" @update:options="onOptionsChange" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item class="px-0 mx-0">
                    <v-card class="size_tab mx-0 px-0" flat>
                        <v-card-text class="px-0 mx-1">
                            <v-row>
                                <v-col class="py-0">
                                    <datatable :showSelect="true" :item_key="'id'" @input:selected="handleSelected($event, 'returned')" v-model="items_selected_returned" :props="{ headers: headers, items: props.items, search: props.search}" :itemsLength="props.meta.total" @update:options="onOptionsChange" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>

        </v-container>     
         <!-- CREATE PICKUP ADDRESS -->
        <v-dialog v-model="modal_create" persistent max-width="90%">
            <v-form ref="create_guide" lazy-validation @submit.prevent="savePA">
                <v-card style="min-width: 650px !important">
                    <v-card-text>
                        <v-row align="center" justify="center" class="pt-1 mt-1 text-center">
                            <v-col cols="11">
                                <h3>{{ $t('guides.create_new_guide') }}</h3>
                            </v-col>
                        </v-row>
                        <br>

                        <v-row class="px-5 py-0 mt-0 mb-2" justify="center" align="center">
                            <v-col cols="11" class="py-0 marker1-1 mx-0 px-0">
                                <label class="mx-0 px-2">{{ $t('guides.origin_data') }}</label>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0" justify="center" align="center" v-if="$store.state.clients.length > 1">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-autocomplete ref="client_id" class="mt-0 py-0" v-model="selected_client_id" :items="$store.state.clients" :label="$t('guides.client')" item-text="name" item-value="id"></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-autocomplete class="py-0 mt-0" v-model="guide.shipping_guide.pickup_address_id" :items="addresses" :label="$t('guides.addresses')" :loading="load_addresses" item-value="id" item-text="address.direction" :rules="rules_required"></v-autocomplete> 
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-autocomplete class="py-0 mt-0" v-model="guide.shipping_guide.subclient_id" :items="subclients" :label="$t('guides.subclients')" :loading="load_subclients" item-value="id" item-text="attributes.name" :rules="rules_required"></v-autocomplete> 
                            </v-col>
                        </v-row>

                        <br>

                        <v-row class="px-5 py-0 mt-0 mb-2" justify="center" align="center">
                            <v-col cols="11" class="py-0 marker1-1 mx-0 px-0">
                                <label class="mx-0 px-2">{{ $t('guides.recipient_data') }}</label>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.recipient.contact.person_name" :rules="rules_required" :label="$t('guides.person_name')"></v-text-field>
                            </v-col>
                        </v-row>

                         <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.recipient.contact.phone_number" :rules="rules_required" :label="$t('guides.phone_number')"></v-text-field>
                            </v-col>
                        </v-row>

                         <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="street_line_1" :rules="rules_required_length" :label="$t('guides.address')"></v-text-field>
                            </v-col>
                        </v-row>

                         <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="street_line_2" :rules="rules_required_length" :label="$t('guides.neighborhood')"></v-text-field>
                            </v-col>
                        </v-row>

                         <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.recipient.address.municipality" :rules="rules_required" :label="$t('guides.municipality')"></v-text-field>
                            </v-col>
                        </v-row>

                         <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.recipient.address.state" :rules="rules_required" :label="$t('guides.state')"></v-text-field>
                            </v-col>
                        </v-row>

                         <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.recipient.address.postal_code" :rules="rules_required" :label="$t('guides.postal_code')"></v-text-field>
                            </v-col>
                        </v-row>

                         <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.recipient.address.comments" :label="$t('guides.comments')"></v-text-field>
                            </v-col>
                        </v-row>

                        <br>
                        
                        <v-row class="px-5 py-0 mt-0 mb-2" justify="center" align="center">
                            <v-col cols="11" class="py-0 marker1-1 mx-0 px-0">
                                <label class="mx-0 px-2">{{ $t('guides.package_item') }}</label>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.package_items[0].reference" :rules="rules_required" :label="$t('guides.reference_number')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.package_items[0].declared_value_mxn" :rules="rules_required" :label="$t('guides.declared_value')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.package_items[0].weight_kg" :rules="rules_required" :label="$t('guides.weight_l')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.package_items[0].dimensions_cm.length" :rules="rules_required" :label="$t('guides.length')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.package_items[0].dimensions_cm.width" :rules="rules_required" :label="$t('guides.width')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0">
                                <v-text-field class="py-0" v-model="guide.shipping_guide.package_items[0].dimensions_cm.height" :rules="rules_required" :label="$t('guides.height')"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 mt-4 mb-1" justify="end" align="end">
                            <v-col cols="11" class="py-0 my-0 mx-0 px-0" justify="end" align="end">
                                <v-btn class="mx-3" text @click="cancelNewGuide()">{{ $t('guides_fees.cancel') }}</v-btn>
                                <v-btn color="secondary" class="white_highlight--text" @click="saveNewGuide()">
                                    {{ $t('guides_fees.save') }}
                                </v-btn>                                
                            </v-col>
                        </v-row>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-form>
        </v-dialog>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { indexByClientGuidesUseCase } from "../../application/use_cases/index_by_client_guides_use_case";
import { HttpGuideRepository } from "../../infrastructure/repositories/guide_repository";
import { downloadGuidesUseCase } from "../../application/use_cases/download_guides_use_case";
import { getGuideBlobUseCase } from "../../application/use_cases/get_guide_blob_use_case";
import { indexSubclientsUseCase } from "../../../subclients/application/use_cases/index_subclients_use_case";
import { HttpSubclientRepository } from "../../../subclients/infrastructure/repositories/subclient_repository";
import { indexPickupAddressesUseCase } from "../../../pickup_addresses/application/use_cases/index_pickup_addresses_use_case";
import { HttpPickupAddressRepository } from "../../../pickup_addresses/infrastructure/pickup_address_repository";
import { createGuideUseCase } from "../../application/use_cases/create_guide_use_case";

import JSZip from 'jszip';
import FileSaver from 'file-saver';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        rules_required_length() {
            return [
                v => !!v || this.$t('create_appointment.validations.required_field'),
                v => v.toString().length <= 35 || this.$t('create_appointment.validations.length'),
            ]
        },
        headers(){
            var headers = [
                { text: this.$t('guides.reference'), align: "center", value: 'client_reference_id', class: 'text-uppercase', sortable: false },
                { text: this.$t('guides.guide_number'), align: "center", value: 'tracking_number', class: 'text-uppercase', sortable: false },
                { text: this.$t('guides.date'), align: "center", value: 'date', class: 'text-uppercase', sortable: false },
                { text: this.$t('guides.weight'), align: "center", value: 'total_weight', class: 'text-uppercase', sortable: false },
                { text: this.$t('guides.origin'), align: "center", value: 'origin', class: 'text-uppercase', sortable: false },
                { text: this.$t('guides.destination'), align: "center", value: 'destination', class: 'text-uppercase', sortable: false },
                { text: this.$t('guides.status'), align: "center", value: 'status', class: 'text-uppercase', sortable: false },
            ];

            if(this.$store.state.clients.length > 1) headers.splice(1, 0, { text: this.$t('guides.customer'), align: "center", value: 'client', class: 'text-uppercase', sortable: false },)

            return headers;
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
                meta: {
                    total: null,
                    total_pages: null,
                    per_page: null,
                    page: null
                },
                sort_by: []
            },
            tab: null,
            global_status: "",
            tab_items: [this.$t('guides.created'), this.$t('guides.in_transit'), this.$t('guides.delivered'), this.$t('guides.returned')],
            items_selected_created: [], 
            items_selected_in_transit: [], 
            items_selected_delivered: [], 
            items_selected_returned: [], 
            modal_create: false,
            guide: {
                client_id: "",
                shipping_guide: {
                    client_reference_id: "",
                    subclient_id: "",
                    pickup_address_id: "",
                    recipient: {
                        contact: {
                            person_name: "",
                            phone_number: ""
                        },
                        address: {
                            street_lines: ["",""],
                            municipality: "",
                            state: "",
                            postal_code: "",
                            country: "México",
                            comments: ""
                        }
                    },
                    package_items: [
                        {
                            reference: "",
                            declared_value_mxn: "",
                            weight_kg: "",
                            dimensions_cm: {
                                length: "",
                                width: "",
                                height: ""
                            }
                        }
                    ]
                }
            },
            subclients: [],
            addresses: [],
            load_addresses: false,
            load_subclients: false,
            street_line_1: "",
            street_line_2: "",
            current_clients: [],
            selected_client_id: "",
        }
    },
    mounted(){
        this.$store.state.module = "headers.guides";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async loadData(status){
            try {
                if (this.props.meta.per_page != null && this.props.meta.page != null) {
                    const response = await indexByClientGuidesUseCase(this.$store.state.clients.map(x => x.id).join(','), this.props.meta.per_page, this.props.meta.page, status, HttpGuideRepository);
                    
                    this.props.items = response.data.success.arguments.data;
                    this.props.meta = response.data.success.arguments.meta;

                    if(this.$store.state.clients.length == 1) this.selected_client_id = this.$store.state.clients[0].id;
                }
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 
            
            this.index();
        },
        async handleSelected(value, type){
            if(type == "created") this.items_selected_created = value;
            else if(type == "in_transit") this.items_selected_in_transit = value;
            else if(type == "delivered") this.items_selected_delivered = value;
            else if(type == "returned") this.items_selected_returned = value;
        },
        async downloadLabels(){
            var current_selected_items = [];
            var zip = new JSZip();

            if(this.tab == 0) current_selected_items = this.items_selected_created;
            else if(this.tab == 1) current_selected_items = this.items_selected_in_transit;
            else if(this.tab == 2) current_selected_items = this.items_selected_delivered;
            else if(this.tab == 3) current_selected_items = this.items_selected_returned;

            var ids = current_selected_items.map(x => x.id)

            try {
                const response = await downloadGuidesUseCase(ids, HttpGuideRepository);
                
                for(let item of response.data.data){
                    const {data} = await getGuideBlobUseCase(item.attributes.download_label_path, HttpGuideRepository);
                    // let blob = new Blob([data], { type: 'png', encoding: 'UTF-8' })

                    zip.file(item.attributes.reference +'.png', data);
                }

                zip.generateAsync({type:"blob"}).then(function(content) {
                    FileSaver.saveAs(content, "labels.zip")
                }, function(err){
                    console.log(err)
                })            
            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },
        async saveNewGuide(){
            const valid = this.$refs.create_guide.validate();
            if(!valid) return;

            this.guide.client_id = this.selected_client_id;
            this.guide.shipping_guide.client_reference_id = this.uuidv4();
            this.guide.shipping_guide.recipient.address.street_lines = [this.street_line_1, this.street_line_2];

            try {
                const response = await createGuideUseCase(this.guide, HttpGuideRepository);
                response;
                this.$refs.create_guide.reset();
                this.modal_create = false;
                this.loadData('created');
            }
            catch(e) {
                console.log(e);

                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }

        },
        cancelNewGuide(){
            this.modal_create = false
            this.$refs.create_guide.reset();
        }
    },
    watch:{
        'tab': async function(){
            var status = this.global_status = "created";
            
            if(this.tab == 0) status = this.global_status = 'created';
            else if(this.tab == 1) status = this.global_status = 'in_transit';
            else if(this.tab == 2) status = this.global_status = 'delivered';
            else if(this.tab == 3) status = this.global_status = 'returned';
            else status = this.global_status = 'created';

            await this.loadData(status);
        },
        'props.meta.page': function(){
            this.loadData(this.global_status);
        },
        'props.meta.per_page': function(){
            this.loadData(this.global_status);
        },
        'selected_client_id': async function() {
            this.subclients = [];
            this.addresses = [];
            this.load_addresses = true;
            this.load_subclients = true;

            this.guide.client_id = this.$store.state.clientId;

            const subclients = await indexSubclientsUseCase(this.selected_client_id, HttpSubclientRepository);
            this.subclients = subclients;
            
            const pickup_addresses = await indexPickupAddressesUseCase(this.selected_client_id, HttpPickupAddressRepository);
            this.addresses = pickup_addresses;

            this.load_addresses = false;
            this.load_subclients = false;
        }
    }
}
</script>

<style>

</style>